import React from 'react'
import { Link } from 'react-router-dom'

const sideMenuDefault = () => <React.Fragment>
	<div><div>
		<p>
		Anschrift:<br/>
			{'Chance \'93 e.V.'}<br/>
		Seerenteichstraße 11<br/>
		01737 Grillenburg<br/>
		</p>
		<p>
		Telefon: 03 52 02 - 5 05 20
		</p>
		<Link to="/kontakt/anfahrt">Anfahrt</Link>
	</div></div>
	<div><div>
		gefördert durch:
		<img src="/assets/Sachsen.png" alt="Sachsen" title="Sachsen" />
		<img src="/assets/landkreis.jpg" alt="Landratsamt Sächsische Schweiz-Osterzgebirge" title="Landratsamt Sächsische Schweiz-Osterzgebirge" />
		<img src="/assets/SMUL_LO_EPLR-RGB-RZ-klein.jpg" alt="Europäischer Landwirtschaftsfonds für die Entwicklung des ländlichen Raums" title="Europäischer Landwirtschaftsfonds für die Entwicklung des ländlichen Raums" />
	</div></div>
</React.Fragment>

export default sideMenuDefault



// WEBPACK FOOTER //
// ./src/components/sideMenuDefault.jsx